import {ApiSortOrder, ApiSortsDerived} from '@/api/meta/odata';
import {getOffers} from '@/api/module/offer';
import Offer, {ApiOffer, OfferFilters} from '@/model/Offer';
import {createVersionedStorage} from './types';
import {ValueType} from '@/api/meta/filters';
import {fulltextToDisplay, toDisplay} from '@/util/store';

// const filterNames: Record<keyof OfferFilters, string | null> = {
//   'AngebotNr': 'Angebots-Nr.',
//   'Erledigt': null,
//   'Fulltext$Fulltext': 'Suche',
//   'KundenNr': 'Kunden-Nr.',
// };

const useOffersStore = createVersionedStorage<
  OfferFilters,
  ApiSortsDerived<ApiOffer>,
  Offer[]
>('offers', {
  fetchFn: getOffers,
  formatter: {
    Fulltext$Fulltext: fulltextToDisplay,
    AngebotNr: toDisplay('Angebots-Nr.'),
  },
  // convertFilterToDisplayFn: createConvertFiltersToDisplayFn(
  //     createGetRowFn({
  //       getLabel: ({actualKeys}) => filterNames[actualKeys[0] as keyof OfferFilters],
  //       isHidden: ({actualKeys}) => actualKeys[0] === 'KundenNr',
  //     }),
  // ),
  defaultData: [],
  defaultFilters: {
    Fulltext$Fulltext: {words: [], fields: [
      {
        path: ['AngebotNr'],
        valueType: ValueType.NumberStartsWith,
      },
      {
        path: ['Positionen', 'ArtikelNr'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['Positionen', 'ArtikelBezeichnung1'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['Positionen', 'ArtikelBezeichnung2'],
        valueType: ValueType.StringContains,
      },
    ]},
  },
  defaultSorts: [['Datum', ApiSortOrder.Desc]],
  defaultLimit: 10,
});

export default useOffersStore;
